module.exports = __webpack_public_path__ + "img/3.6c11e6a8.png";